import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { connect } from 'react-redux';
import { DiscoverState } from '../../../../../types';
import { ThingsToDoShelfState } from '../../../../../types/ThingsToDoShelf';

import styles from './ThingsToDoSection.module.scss';

export const ThingsToDoShelfSection = ({
    tags,
    header,
}: ThingsToDoShelfState) => {
    const headerTitle = gettext('Things to do around %(geo)s', {
        geo: header.placeName,
    });

    if (tags.length > 0) {
        return (
            <section className={styles.thingsToDoSection}>
                <Typography as="h2" variant="heading-sm">
                    <a href={header.url}>{headerTitle}</a>
                </Typography>

                <div className={styles.citiesWrapper}>
                    {tags.map((tag) => (
                        <a
                            key={tag.placeName}
                            className={styles.city}
                            href={tag.linkUrl}
                        >
                            {gettext('Things to do in %(place)s', {
                                place: tag.placeName,
                            })}
                        </a>
                    ))}
                </div>
            </section>
        );
    } else {
        return null;
    }
};

export const _mapStateToProps = (state: DiscoverState) => {
    return {
        tags: state.thingsToDoShelf.tags,
        header: state.thingsToDoShelf.header,
    };
};

export default connect(_mapStateToProps)(ThingsToDoShelfSection);
